const EmptyImage = ({classes = ''})=>{
  return (
    <img src="/images/no-image.png" className={`width_full ${classes}`} alt=""/>
  );
}
export default EmptyImage;